import {FormPaperColorEnum, FormPrintColorEnum, LabelConfigType} from "../Types";
import * as Catalogue from "../LabelTypes/Catalogue";
import * as Catalogue2 from "../LabelTypes/Catalogue2";
import * as Impact from "../LabelTypes/Impact";

export const LABELS_CONFIG: LabelConfigType[] = [
  /*{
    name: "Catalogue",
    preview: Catalogue.getPreview(),
    printOptions: {
      sizes: ['A4', 'A5', 'A6', 'A7'],
      orientations: {
        portrait: ['A4', 'A5'],
        landscape: ['A4', 'A5', 'A6', 'A7'],
      },
      printColors: [FormPrintColorEnum.BW, FormPrintColorEnum.COLOR],
      paperColors: [FormPaperColorEnum.WHITE, FormPaperColorEnum.YELLOW],
    },
    getDefaultPrintOptions: Catalogue.getDefaultPrintOptions,
    getDefaultLabel: Catalogue.getDefaultLabel,
    components: {
      form: Catalogue.Form,
      pdf: Catalogue.Pdf,
    },
  },*/
  {
    name: "Catalogue",
    preview: Catalogue2.getPreview(),
    printOptions: {
      sizes: ['A4', 'A5', 'A6', 'A7'],
      orientations: {
        portrait: ['A4', 'A5'],
        landscape: ['A4', 'A5', 'A6', 'A7'],
      },
      printColors: [FormPrintColorEnum.BW, FormPrintColorEnum.COLOR],
      paperColors: [FormPaperColorEnum.WHITE, FormPaperColorEnum.YELLOW],
    },
    getDefaultPrintOptions: Catalogue2.getDefaultPrintOptions,
    getDefaultLabel: Catalogue2.getDefaultLabel,
    components: {
      form: Catalogue2.Form,
      pdf: Catalogue2.Pdf,
    },
  },
  {
    name: "Impact",
    preview: Impact.getPreview(),
    printOptions: {
      sizes: ['A4', 'A5', 'A6', 'A7'],
      orientations: {
        portrait: ['A4', 'A5', 'A6', 'A7'],
        landscape: ['A4', 'A5', 'A6', 'A7'],
      },
      printColors: [FormPrintColorEnum.BW, FormPrintColorEnum.COLOR],
      paperColors: [FormPaperColorEnum.WHITE, FormPaperColorEnum.YELLOW],
    },
    getDefaultPrintOptions: Impact.getDefaultPrintOptions,
    getDefaultLabel: Impact.getDefaultLabel,
    components: {
      form: Impact.Form,
      pdf: Impact.Pdf,
    },
  }
];
